/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsExtendedModule
 * Purpose		: Module for OrderDetailsExtended.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { OrderDetailsExtendedService } from './OrderDetailsExtended.service';
import { OrderDetailsExtendedListComponent } from './OrderDetailsExtendedList.component';
import { OrderDetailsExtendedSearchComponent } from './OrderDetailsExtendedSearch.component';
import { OrderDetailsExtendedDetailsComponent } from './OrderDetailsExtendedDetails.component';

import { OrderDetailsExtendedRoutingModule } from './OrderDetailsExtended-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    OrderDetailsExtendedRoutingModule
  ],
  declarations: [
    OrderDetailsExtendedListComponent,
	OrderDetailsExtendedSearchComponent,
	OrderDetailsExtendedDetailsComponent
  ],
  providers: [
    OrderDetailsExtendedService
  ]
})

export class OrderDetailsExtendedModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetailsExtended/OrderDetailsExtended.module.ts